import React from 'react';
import LSM from '../../../modules/cache/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from '../../../modules/cache/local-storage.constant';
import i18n from '../../../i18n';
import { apiManage_rbp } from '../../../request';
import GlobalNotification from '../../../component/common/snackbar';
import _ from 'lodash';
import Card from '../Card';
import { Box, Grid, Typography } from '@mui/material';
import CommonInput from '../../../component/form/common-input.component';
import { Condiment } from '../../../models/condiment.entity';
import ButtonComponent from '../../../component/button/button.component';
import BASE_CHECK_TYPE from '../../../constants/regular.constant';


/**
 * 调味品单品详情
 */
class CondimentDetail extends React.Component<Props, State> {
    // 从缓存中拿服务器地址
    public SERVER_URL = LSM.get(LOCAL_STORAGE_KEYS.SERVER_URL);
    // 是否意大利国家
    public isItaly = LSM.get(LOCAL_STORAGE_KEYS.RBP_RESTAURANT_COUNTRY) === 'Italy';
    public state: State = {
        // 详情
        detail: _.cloneDeep(this.props.detail) || {},
        // 加载中
        isLoading: false,
    }
    // *********************
    // Life Cycle Function
    // *********************

    componentDidMount() {
        this.init();
    }

    // *********************
    // Default Function
    // *********************

    /**
     * 初始化
     */
    init() {
        const { detail } = this.state;
        detail.item_name1 = detail.item_name1 ?? `Condiment ${this.props.lastId}`;
        detail.price_1 = detail.price_1 ?? 0;
        detail.major_group = detail.major_group || -1;
        detail.family_group = detail.family_group || -1;
        detail.tax_group = detail.tax_group || -1;
        this.setState({
            detail
        })

    }

    /**
     * 保存
     */
    async onSave() {
        const { detail } = this.state;
        // 菜品名称必填
        if (!_.trim(detail.item_name1)) {
            return;
        }
        // 意大利--菜品名称
        if (this.isItaly && !(BASE_CHECK_TYPE.dishNameAndNlu2.regular.test(detail.item_name1 ?? ''))) {
            GlobalNotification.error(i18n.t('input_rule_text_enter_dish_name_and_nlu_regular2'));
            return;
        }
        // setLinearLoading(true);
        // 菜品详情
        let result;
        // 编辑
        if (detail.item_id) {
            const params = {
                item_id: detail.item_id,
                item_name1: detail.item_name1,
                item_name2: detail.item_name2,
                price_1: detail.price_1 || 0,
                tax_group: detail.tax_group,
                family_group: detail.family_group,
                major_group: detail.major_group,
                takeout_price_1: detail.takeout_price_1 || 0,
                unit_1: detail.unit_1 || '',
            }
            result = await apiManage_rbp.patch_condiment(params);
        }
        // 新增
        else {
            detail.item_id = this.props.lastId;
            result = await apiManage_rbp.post_condiment(detail);
        }

        // 请求成功
        if (!_.get(result, 'error')) {
            // 刷新菜单数据
            await this.props.getMenuData();
            GlobalNotification.success(i18n.t('global_text_operate_success'));
            this.setState({
                detail,
            });
            // 返回上一层
            this.props.handleClickBack()
        }
        // 请求失败
        else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
        }
        // setLinearLoading(false);
    }


    /**
     * 表单回调
     * @param value
     * @param key
     */
    onChange(value: number | string | string[], key: string) {
        const { detail } = this.state;
        let newValue = value;
        // 价格做处理
        if (key === 'price_1' || key === 'takeout_price_1') {
            if (value && Number(value) < 0) {
                newValue = 0
            }
            else if (value) {
                newValue = Number(Number(value).toFixed(2))
            }
        }
        _.set(detail, key, newValue)
        this.setState({
            detail
        })
    }



    // *********************
    // View
    // *********************

    render() {
        const { majorGroupList, taxGroup, familyGroupList, unitList } = this.props;
        const { detail } = this.state;
        // 表单
        const formArr = [
            {
                key: 'item_name1',
                label: i18n.t('global_text_name'),
                regularType: this.isItaly ? 'dishNameAndNlu2' : 'required',
                require: true,
            },
            // {
            //     key: 'item_name2',
            //     label: 'item_name2',
            // },
            {
                key: 'price_1',
                label: i18n.t('menu_and_dishes_page_dine_in_price'),
                type: 'number'
            },
            {
                key: 'takeout_price_1',
                label: i18n.t('menu_and_dishes_page_takeout_price'),
                type: 'number'
            },
            {
                key: 'tax_group',
                label: i18n.t('tax_group_page_label'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: taxGroup
            },
            {
                key: 'unit_1',
                label: i18n.t('menu_and_dishes_page_specification'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: unitList
            },
            {
                key: 'major_group',
                label: i18n.t('condiment_page_custom_form_main_type'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: majorGroupList
            },
            {
                key: 'family_group',
                label: i18n.t('condiment_page_custom_form_sub_type'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: familyGroupList
            }

        ]
        return (
            <Card
                title={(
                    <Box display='flex' alignItems='center'>
                        <ButtonComponent
                            action='BACK'
                            handleClick={() => {
                                this.props.handleClickBack()
                            }}
                        />
                        <Typography>
                            {(detail.item_id || (detail.item_id === 0)) ? i18n.t('condiment_page_edit_condiment') : i18n.t('condiment_page_add_condiment')}
                        </Typography>
                    </Box>
                )}
                actionRender={(
                    <ButtonComponent
                        action='SAVE'
                        handleClick={async () => {
                            await this.onSave();
                        }}
                    />
                )}
                contentRender={(
                    <Grid container spacing={4}>
                        {
                            formArr.map((item) => (
                                <Grid key={item.key} item xs={12} sm={6}>
                                    <CommonInput
                                        type={item.type}
                                        select={item.select}
                                        items={item.items || []}
                                        required={item.require}
                                        regularType={item.regularType}
                                        variant={'outlined'}
                                        fullWidth
                                        label={item.label}
                                        value={_.get(detail, item.key) ?? ''}
                                        onChange={(event: any) => {
                                            this.onChange(event.target.value, item.key)
                                        }}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>
                )}
            />
        )
    }
}

export default CondimentDetail;

// *********************
// Type
// *********************
type Props = {
    // 菜品详情
    detail: Condiment;
    // 返回
    handleClickBack: () => void;
    // 刷新菜单数据
    getMenuData: () => Promise<void>;
    // 税率组列表
    taxGroup: { label: string; value: number; }[];
    // 当前最大id
    lastId: number;
    // 自定义报表主类别
    majorGroupList: { label: string; value: number; }[];
    // 自定义报表子类别
    familyGroupList: { label: string; value: number; }[];
    // 规格设置
    unitList: { label: string; value: string; }[];
}
type State = {
    // 菜品详情
    detail: Condiment
    // 加载中
    isLoading: boolean;
}